import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { compose } from 'redux';
import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
} from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import BrochurePageComponent from '../../components/BrochurePage/BrochurePageComponent';
import { ReactComponent as LineSmallSvgNew } from '../../assets/crissCrossSmallNew.svg';
import css from './foodpage.module.css';
const HeadingTextMob = () => {
  return (
    <p className={`${css.firstHeaderTop} ${css.showForMob}`}>
      Share your 
      {/* <br /> */}
      <span className={css.tiltedHeighlight}>
        {' '}
        <span className={css.innerTiltText}>love of food</span>
      </span>{' '}
      — we’ll handle the{' '}
      <div className={css.headerStyle}>
        <LineSmallSvgNew className={`${css.lineSvg}`} />
        admin
      </div>
    </p>
  );
};

const HeaderText = () => {
  return (
    <p className={`${css.firstHeaderTop} ${css.hideForMob}`}>
      Share your 
      {/* <br /> */}
      <span className={css.tiltedHeighlight}>
        {' '}
        <span className={css.innerTiltText}>love of food</span>
      </span>{' '}
      — we’ll handle the{' '}
      <div className={css.headerStyle}>
        <LineSmallSvgNew className={`${css.lineSvg}`} />
        admin
      </div>
    </p>
  );
};

function FoodPage(props) {
  const { isAuthenticated, currentUser } = props;
  const isProvider = currentUser?.attributes?.profile?.publicData?.isProvider;
  const pageDescription = `Whether you love teaching kids how to bake cupcakes, teens how to make fresh pasta or showing adults how to master sourdough — we’re here to help you manage the details behind the scenes. From registrations and payments to sign-in sheets and reminders, Activity Time keeps your kitchen stress-free so you can focus on the joy of cooking and inspiring your next group of chefs.`;
  return (
    <Page>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <BrochurePageComponent
            isAuthenticated={isAuthenticated}
            isProvider={isProvider}
            headingText={<HeaderText />}
            headingTextMob={<HeadingTextMob />}
            pageName="Cooking & Baking"
            pageDescription={pageDescription}
            pageBannerImg={`food_bannerImage.png`}
            secondSecTitle={
              'Discover an admin-loving sous chef - who never sleeps!'
            }
            secondSecSubTitle={
              'See how our activity registration and management software can be the secret ingredient to growing your business.'
            }
            secondSecMainPic={'food_secondMain.png'}
            secondSecLogo={'food_secondLogo.png'}
            secondSecName={'Gillian'}
            secondSecNameDes={'Cooking Skills Workshops'}
            secondSecDesc={`"With Activity Time I choose how much to take by card and how much in cash. It’s flexible, puts me in control, and helps parents commit upfront. Also saves hours with the auto-fill sign-in sheets and coordinated attendee lists."`}
            secondSecSub={'Let’s make cooking '}
            thirdSecFirstTitle={`Cook. Create. Inspire. We'll handle the rest.`}
            thirdSecSecondTitle={`Dish out your best, every day.`}
            thirdSecFirstPic={`food_thirdFirst.png`}
            thierdSecSecondPic={`food_thirdSecond.png`}
            thirdSecParaText={`We know magic happens in the kitchen, not in spreadsheets!`}
            testimonialPic={`inclusive_testiminialImg.png`}
            testimonialTitle={`Maya, Inclusive Yoga Classes`}
            testimonialDesc={`“Before Activity Time, I spent evenings chasing messages, checking lists and payments. Now, I always get paid in full and do all admin in minutes. It’s been a huge relief — simple and easy.”`}
          />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <div className={css.footerWrapper}>
            <Footer hideFirstWave={true} />
          </div>
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
}
const mapStateToProps = state => {
  const { currentUserListing, currentUserListingFetched, currentUser } = state.user;
  const { isAuthenticated } = state.Auth || {};

  return {
    currentUserListing,
    currentUserListingFetched,
    currentUser,
    isAuthenticated,
  };
};
export default compose(withRouter, connect(mapStateToProps), injectIntl)(FoodPage);
